import script from "./UploadCategoryAlias.vue?vue&type=script&setup=true&lang=js"
export * from "./UploadCategoryAlias.vue?vue&type=script&setup=true&lang=js"

import "./UploadCategoryAlias.vue?vue&type=style&index=0&id=0848f126&lang=css"

const __exports__ = script;

export default __exports__